import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout/Layout';
import AuthForm from '../components/Auth/AuthForm';
import elegantBallerina from '../assets/artistic_ballerina_shot.jpg';

const Login = () => {
  return (
    <Layout
      title="Sign In | Prix du Canada Ballet Competition"
      description="Sign in to your Prix du Canada account to access your dancer profile, manage registrations, and explore exclusive workshops."
      keywords="ballet competition login, Prix du Canada sign in, dancer account, ballet registration login"
    >
      {/* Elegant Hero Section */}
      <section className="elegant-hero">
        <div className="hero-background">
          <img src={elegantBallerina} alt="Elegant ballet dancer" style={{opacity: 0.08}} />
        </div>
        <div className="container">
          <h1>Welcome Back</h1>
          <p style={{textAlign: 'center', fontSize: '1.3rem', maxWidth: '700px', margin: '0 auto'}}>
            Sign in to access your dancer profile, manage your competition registrations, and continue your journey to the professional stage.
          </p>
        </div>
      </section>

      {/* Login Form Section */}
      <section className="section" style={{background: 'var(--light-gray)', paddingTop: '4rem', paddingBottom: '4rem'}}>
        <div className="container">
          <AuthForm
            defaultTab="login"
            title="Sign In to Your Account"
            subtitle="Access your profile and continue your dance journey"
          />

          <p style={{textAlign: 'center', marginTop: '2rem', fontSize: '1rem', color: 'var(--soft-gray)'}}>
            Don't have an account?{' '}
            <Link
              to="/register"
              style={{
                color: 'var(--primary-gold)',
                textDecoration: 'none',
                fontWeight: 600
              }}
            >
              Create one now
            </Link>
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default Login;
